import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  profileInfo: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  textHeading: {
    fontSize: "18px",
    color: "#2158D0",
    fontWeight: 700,
    fontFamily: "Inter",
  },
  communities: {
    width:"100%",
    borderBottom: "none",
    marginTop:"20px",
    boxShadow: "none",
    [theme.breakpoints.down("sm")]: {
      marginRight: "44px",
    },
    "& .MuiAccordionSummary-root":{
      backgroundColor: "#5C91FF",
    },
    "& .MuiAccordionSummary-content": {
      justifyContent: "center",
      alignItems: "center",
    },
    "& .MuiAccordionSummary-content p": {
      color: "#FFFFFF",
      fontFamily: "Inter",
      fontSize: "18px",
    },
    "& .MuiIconButton-label": {
      color: "#FFFFFF",
    },
  },
  communitiesAccordianCard: {
    backgroundColor: "#FFFFFF", 
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", 
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderRadius: "12px",
    justifyContent: "space-between",
    padding: "10px",
    "& .MuiTypography-root": {
    color: "#2158D0",  
  },
  },
  menuAccordian:{
    width:"100%",
    borderBottom: "none",
    boxShadow: "none",
    "& .MuiAccordionSummary-root":{
      padding:"0px"
    }
    
  },
  accordionSummary: {
    borderBottom: "none !important",
    width: "100%",
    padding: "0px !important",
    minHeight: "auto !important",
    "& .MuiListItemText-root":{
      paddingLeft: "10px"
    }
  },
  listItemText:{
    marginTop:"20px",
    fontFamily:"MontserratRegular",
    fontWeight: 400,
    lineHeight:'20.15px',
    color: "red"
  }
  
}));
